export interface ReferencePeriod {
    month: string;
    year: number;
    endDateTime: string;
}

export interface PeriodMetrics {
    generatedEnergyMwh: number;
    injectedEnergyMwh: number;
    expectedEnergyMwh: number;
    correctedExpectedEnergyMwh: number;
    efficiencyPercent: number;
    irradiancePoaKwhM2: number;
    irradianceGhiKwhM2: number;
    expectedIrradianceKwhM2: number;
    basicPrPercent: number;
    normalizedPrPercent: number;
}

export interface PeriodRow extends PeriodMetrics {
    label: string;
    firstDay?: string | null;
    lastDay?: string | null;
}

export type PeriodTotals = PeriodMetrics;

export interface PeriodTable {
    rows: PeriodRow[];
    totals: PeriodTotals;
}

export interface TechnicalData {
    address: string;
    latitude: string;
    longitude: string;
    city: string;
    state: string;
    zipCode: string;
    maxPowerMw: number;
    nominalCapacityMw: number;
    skidCount: number;
    invertersText: string;
}

export interface GaugeValue {
    actualPercent: number;
    expectedPercent: number;
}

export interface PerformanceRatioSummary {
    basic: GaugeValue;
    normalized: GaugeValue;
}

export type StringSeries = string[];
export type NumberSeries = number[];

export interface WeeklyChartData {
    categories: StringSeries;
    generatedEnergyMwh: NumberSeries;
    expectedEnergyMwh: NumberSeries;
    correctedExpectedEnergyMwh: NumberSeries;
    irradiancePoaKwhM2: NumberSeries;
    irradianceGhiKwhM2: NumberSeries;
}

export interface MonthlyChartData {
    categories: StringSeries;
    irradiancePoaKwhM2: NumberSeries;
    irradianceGhiKwhM2: NumberSeries;
    expectedIrradianceKwhM2: NumberSeries;
    basicPrPercent: NumberSeries;
    basicPrTrendPercent: NumberSeries;
    normalizedPrPercent: NumberSeries;
    normalizedPrTrendPercent: NumberSeries;
}

export interface OverviewChartData {
    weekly: WeeklyChartData;
    monthly: MonthlyChartData;
}

export interface DailyDay {
    date: string;
    withinReferenceMonth: boolean;
}

export interface DailyMetricRow {
    label: string;
    values: [string, string, string, string, string, string, string];
}

export interface DailyWeek {
    weekName: string;
    days: [DailyDay, DailyDay, DailyDay, DailyDay, DailyDay, DailyDay, DailyDay];
    rows: [DailyMetricRow, DailyMetricRow, DailyMetricRow, DailyMetricRow, DailyMetricRow];
}

export interface StationOverview {
    stationId: number;
    stationName: string;
    technicalData: TechnicalData;
    monthlyTable: PeriodTable;
    weeklyTable: PeriodTable;
    performanceRatio: PerformanceRatioSummary;
    charts: OverviewChartData;
    dailyWeeks: [
        DailyWeek,
        DailyWeek,
        DailyWeek,
        DailyWeek,
        DailyWeek,
        DailyWeek
    ];
}

export interface ManagementOverviewResponse {
    customerName: string;
    referencePeriod: ReferencePeriod;
    generatedOn: string;
    stations: StationOverview[];
}

export interface ManagementOverviewRequestParams {
    powerStationIds: number[];
    endDateTime: string;
}

export type ManagementOverviewPageState =
    | 'carregando'
    | 'sucesso'
    | 'sem-dados'
    | 'erro';

export const MANAGEMENT_OVERVIEW_NO_DATA_MESSAGE =
    'Dados não encontrados para esse período';

export const MANAGEMENT_OVERVIEW_ERROR_MESSAGE =
    'Falha ao gerar o relatório. Por favor tente novamente';

export const MANAGEMENT_OVERVIEW_POPUP_BLOCKED_MESSAGE =
    'Não foi possível abrir a nova aba. Verifique se o bloqueador de pop-ups está desativado.';
